// Club reference data, carried over from the design export. `code` is the badge
// abbreviation, and the remaining fields feed the club page identity card.
// Order: [code, stadium, capacity, manager, founded, nickname]
export const CLUB_META = {
  "Manchester City": [
    "MCI",
    "Etihad Stadium",
    "53,400",
    "Pep Guardiola",
    1880,
    "The Citizens",
  ],
  Arsenal: [
    "ARS",
    "Emirates Stadium",
    "60,704",
    "Mikel Arteta",
    1886,
    "The Gunners",
  ],
  Liverpool: ["LIV", "Anfield", "61,276", "Arne Slot", 1892, "The Reds"],
  Chelsea: [
    "CHE",
    "Stamford Bridge",
    "40,343",
    "Enzo Maresca",
    1905,
    "The Blues",
  ],
  "Aston Villa": [
    "AVL",
    "Villa Park",
    "42,657",
    "Unai Emery",
    1874,
    "The Villans",
  ],
  Newcastle: [
    "NEW",
    "St James' Park",
    "52,305",
    "Eddie Howe",
    1892,
    "The Magpies",
  ],
  Tottenham: [
    "TOT",
    "Tottenham Hotspur Stadium",
    "62,850",
    "Thomas Frank",
    1882,
    "Spurs",
  ],
  "Tottenham Hotspur": [
    "TOT",
    "Tottenham Hotspur Stadium",
    "62,850",
    "Thomas Frank",
    1882,
    "Spurs",
  ],
  Brighton: [
    "BHA",
    "Amex Stadium",
    "31,876",
    "Fabian Hürzeler",
    1901,
    "The Seagulls",
  ],
  "Nottingham Forest": [
    "NFO",
    "City Ground",
    "30,404",
    "Nuno Espírito Santo",
    1865,
    "The Tricky Trees",
  ],
  "Nottm Forest": [
    "NFO",
    "City Ground",
    "30,404",
    "Nuno Espírito Santo",
    1865,
    "The Tricky Trees",
  ],
  Bournemouth: [
    "BOU",
    "Vitality Stadium",
    "11,307",
    "Andoni Iraola",
    1899,
    "The Cherries",
  ],
  Fulham: [
    "FUL",
    "Craven Cottage",
    "29,589",
    "Marco Silva",
    1879,
    "The Cottagers",
  ],
  "West Ham": [
    "WHU",
    "London Stadium",
    "62,500",
    "Graham Potter",
    1895,
    "The Irons",
  ],
  Everton: [
    "EVE",
    "Hill Dickinson Stadium",
    "52,888",
    "David Moyes",
    1878,
    "The Toffees",
  ],
  "Crystal Palace": [
    "CRY",
    "Selhurst Park",
    "25,486",
    "Oliver Glasner",
    1905,
    "The Eagles",
  ],
  "Manchester United": [
    "MUN",
    "Old Trafford",
    "74,310",
    "Rúben Amorim",
    1878,
    "The Red Devils",
  ],
  Wolves: ["WOL", "Molineux", "31,750", "Vítor Pereira", 1877, "Wolves"],
  "Leeds United": [
    "LEE",
    "Elland Road",
    "37,645",
    "Daniel Farke",
    1919,
    "The Whites",
  ],
  Burnley: ["BUR", "Turf Moor", "21,944", "Scott Parker", 1882, "The Clarets"],
  Sunderland: [
    "SUN",
    "Stadium of Light",
    "49,000",
    "Régis Le Bris",
    1879,
    "The Black Cats",
  ],
  "Ipswich Town": [
    "IPS",
    "Portman Road",
    "30,311",
    "Kieran McKenna",
    1878,
    "The Tractor Boys",
  ],
  "Bayern München": [
    "BAY",
    "Allianz Arena",
    "75,024",
    "Vincent Kompany",
    1900,
    "Die Roten",
  ],
  "Real Madrid": [
    "RMA",
    "Santiago Bernabéu",
    "78,297",
    "Xabi Alonso",
    1902,
    "Los Blancos",
  ],
  Inter: ["INT", "San Siro", "75,923", "Cristian Chivu", 1908, "Nerazzurri"],
  "Sporting CP": [
    "SPO",
    "Estádio José Alvalade",
    "50,095",
    "Rui Borges",
    1906,
    "Os Leões",
  ],
  "Atlético Madrid": [
    "ATM",
    "Metropolitano",
    "70,460",
    "Diego Simeone",
    1903,
    "Los Colchoneros",
  ],
  PSV: ["PSV", "Philips Stadion", "35,000", "Peter Bosz", 1913, "Boeren"],
  Juventus: [
    "JUV",
    "Allianz Stadium",
    "41,507",
    "Luciano Spalletti",
    1897,
    "La Vecchia Signora",
  ],
  Watford: [
    "WAT",
    "Vicarage Road",
    "22,200",
    "Javi Gracia",
    1881,
    "The Hornets",
  ],
  "Luton Town": [
    "LUT",
    "Kenilworth Road",
    "11,500",
    "Matt Bloomfield",
    1885,
    "The Hatters",
  ],
  Brentford: [
    "BRE",
    "Gtech Community Stadium",
    "17,250",
    "Keith Andrews",
    1889,
    "The Bees",
  ],
  "Al Ain": [
    "AIN",
    "Hazza bin Zayed",
    "25,053",
    "Vladimir Ivić",
    1968,
    "The Boss",
  ],
  "Wydad AC": [
    "WAC",
    "Stade Mohammed V",
    "45,000",
    "Amine Benhachem",
    1937,
    "Le Wydad",
  ],
  "Al Hilal": [
    "HIL",
    "Kingdom Arena",
    "25,000",
    "Simone Inzaghi",
    1957,
    "The Leader",
  ],
  Feyenoord: [
    "FEY",
    "De Kuip",
    "47,500",
    "Robin van Persie",
    1908,
    "De Stadionclub",
  ],
  "Slavia Praha": [
    "SLA",
    "Eden Aréna",
    "19,370",
    "Jindřich Trpišovský",
    1892,
    "Sešívaní",
  ],
  Palermo: [
    "PAL",
    "Renzo Barbera",
    "36,349",
    "Filippo Inzaghi",
    1900,
    "Rosanero",
  ],
};

export const CLUB_ALIAS = {
  "Nottm Forest": "Nottingham Forest",
  "Tottenham Hotspur": "Tottenham",
  "Manchester Utd": "Manchester United",
  "Man City": "Manchester City",
  Spurs: "Tottenham",
};

// Badge fills for clubs the crest set does not cover; the API supplies real
// badge images, these are the fallback discs.
export const CLUB_BADGE = {
  "Manchester City": ["#6CABDD", "#1C2C5B"],
  Arsenal: ["#EC3325", "#fff"],
  Liverpool: ["#C8102E", "#fff"],
  Chelsea: ["#034694", "#fff"],
  Tottenham: ["#132257", "#fff"],
  Newcastle: ["#241F20", "#fff"],
  "Aston Villa": ["#95BFE5", "#670E36"],
  Everton: ["#003399", "#fff"],
  "Real Madrid": ["#FFC659", "#1C2C5B"],
  "Bayern München": ["#DC052D", "#fff"],
};

export const CODE_BADGE = {
  AVL: ["#95BFE5", "#670E36"],
  TOT: ["#132257", "#fff"],
  RMA: ["#FFC659", "#1C2C5B"],
  EVE: ["#003399", "#fff"],
  ARS: ["#EC3325", "#fff"],
  WOL: ["#FDB913", "#231F20"],
  BRE: ["#E30613", "#fff"],
  LIV: ["#C8102E", "#fff"],
  NEW: ["#241F20", "#fff"],
  CHE: ["#034694", "#fff"],
  SPO: ["#2FA46A", "#fff"],
  INT: ["#0B1560", "#fff"],
  BAY: ["#DC052D", "#fff"],
  WAT: ["#FBEE23", "#231F20"],
  BHA: ["#0057B8", "#fff"],
  FUL: ["#E9EEF5", "#111"],
  PSV: ["#EE2223", "#fff"],
  FEY: ["#D4121A", "#fff"],
  SLA: ["#D7141A", "#fff"],
};

export function resolveClub(rawName, known) {
  if (!rawName) return rawName;
  if (known && known(rawName)) return rawName;
  return CLUB_ALIAS[rawName] || rawName;
}

export function clubFromCode(code) {
  const hit = Object.keys(CLUB_META).find((k) => CLUB_META[k][0] === code);
  return hit || code;
}

export function badgeFor(name) {
  return CLUB_BADGE[name] || ["#6CABDD", "#1C2C5B"];
}
